/* eslint-disable prefer-template */
import Layout from "../../../../components/Layout";
import useStyles from "../../styles";
import Button from "../../../../components/Button";
import PageTitle from "../../../../components/PageTitle";
import BreadCrumb from "../../../../components/BreadCrumb";
import { useState, useEffect } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import { Icon } from "@iconify/react";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Grid, FormControlLabel, Switch, Tooltip } from "@mui/material";
import Badge from "../../../../components/Badge";
import { httprequest } from "../../../../data/api";
import { useParams, Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import WidgetTitle from "../../../dashboard/components/WidgetTitle/WidgetTitle";
import Table from "../../../../components/Table/Table";
import { TableSearch } from "../../../../components/Table/TableActions";
import AssignmentDetailText from "../../../assignment/components/AssignmentDetailText";
import { saveAs } from "file-saver";
import HTMLDocx from "html-docx-js/dist/html-docx";
import Modal from "../../../../components/Modal";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import InputGroup from "../../../../components/FormComponent/InputGroup";
import useValidator from "../../../../hooks/useValidator";
import useWindowSize from "../../../../hooks/useWindow";
import { questionDisplayIndex } from "../../../../utils/questionDisplayIndex";
import NotFounditem from "../../../error/NotFound";
import noexam from "../../../../assets/images/noexam.svg";
import RightDrawer from "../../../../components/RightDrawer";
import TextAreaGroup from "../../../../components/FormComponent/TextAreaGroup";
import { useUserState } from "../../../../context/UserContext";
import GenerateQuestionsDrawer from "../../../lessonnote/component/GenerateQuestionsDrawer";

const ENROLMENT_EXAM_ENDPOINT = "/api/v1/enrolment-exams";
const ENROLMENT_EXAM_CONFIG_ENDPOINT = "/api/v1/enrolment-exam-configs";
const UPLOAD_ENDPOINT = "/api/v1/upload";

const questionTypeOptions = [
  { value: "multiple_choice", text: "Multiple Choice" },
  { value: "true_false", text: "True / False" },
  { value: "checkbox", text: "Checkbox" }
];

function QuestionsModalContent(props) {
  const {
    questionArr,
    classes,
    validator,
    isSmallScreen,
    onQueChange,
    onQueTypeChange,
    onQuePointChange,
    onMultipleChoiceChange,
    onCorrectChoiceChange,
    onAdditionalOptions,
    onAdditionalQuestion,
    onRemoveQuestion,
    isDraftLoading,
    isPrimaryLoading,
    onSaveDraft,
    onPrimaryAction,
    primaryButtonLabel,
    footerMode = "add",
    onEditPublish,
    onEditWithdraw,
    isEditPublishing = false,
    isWithdrawLoading = false,
    hideAddQuestionAction = false,
    onQueImageChange,
    onOptionImageChange,
    onRemoveQueImage,
    onRemoveOptionImage,
    onIconClick,
    onIconOptionClick
  } = props;

  return (
    <>
      <div className="margin-top">
        <Grid container spacing={2}>
          {(questionArr || []).map((que, queInd) => (
            <Grid item lg={12} md={12} sm={12} xs={12} key={queInd}>
              <div className={classes.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.quesaction}>
                      <label className={classes.quelabel}>Enter Question {queInd + 1}</label>
                      {(questionArr?.length ?? 0) > 1 ? (
                        <Icon
                          icon="material-symbols:delete-outline"
                          width="20"
                          height="20"
                          className="delete-icon"
                          onClick={() => onRemoveQuestion(queInd)}
                        />
                      ) : null}
                    </div>
                    <div className={classes.textandimgmain}>
                      <div className={classes.textandimg}>
                        <input
                          type="text"
                          placeholder={que?.file?.file_url ? "" : "Type Question"}
                          name="question_text"
                          value={que?.question_text ?? ""}
                          onChange={(e) => onQueChange(e, queInd)}
                        />
                        {validator.message(`question_${queInd}`, (que?.question_text ?? "").trim(), "required")}

                        <div onClick={() => onIconClick(`imageInput-${queInd}`)} className={classes.queimg}>
                          <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                          <input
                            type="file"
                            accept="image/*"
                            id={`imageInput-${queInd}`}
                            multiple
                            onChange={(e) => onQueImageChange(e, queInd)}
                            style={{ display: "none" }}
                          />
                        </div>

                        {que?.file?.file_url ? (
                          <div className={classes.preiewcont}>
                            <img src={que.file.file_url} alt="" />
                            <Icon
                              icon="material-symbols:delete-outline"
                              width="20"
                              height="20"
                              className="delete-icon"
                              onClick={() => onRemoveQueImage(queInd)}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Add Answer Type"
                      required
                      children={
                        <select name="type" value={que?.type ?? ""} onChange={(e) => onQueTypeChange(e, queInd)}>
                          <option value="">--- Select ---</option>
                          {questionTypeOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.text}</option>
                          ))}
                        </select>
                      }
                    />
                    {validator.message(`type_${queInd}`, que?.type, "required")}
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      className={classes.pointsInput}
                      label="Question Point"
                      inputType="number"
                      inputName="grade_point"
                      placeHolder="Enter Question Points"
                      value={que?.grade_point ?? 0}
                      onChange={(e) => onQuePointChange(e, queInd)}
                    />
                    {validator.message(`points_${queInd}`, que?.grade_point, "required")}
                  </Grid>
                </Grid>

                {(que?.type === "multiple_choice" || que?.type === "checkbox" || que?.type === "true_false") && (
                  <Grid container spacing={2} sx={{ marginTop: 1 }}>
                    {(que?.options || []).map((opt, i) => (
                      <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                        <div>
                          <div className=" flex gap-10 justify-items-space">
                            <label className={classes.enterque}>Option {i + 1}<span className="input-required"> *</span></label>
                            {que?.options?.length > 1 && que?.type !== "true_false" ? (
                              <Icon
                                onClick={() => {
                                  // remove option
                                  const next = [...(que?.options || [])].filter((_o, idx) => idx !== i);
                                  const nextQuestions = [...questionArr];
                                  nextQuestions[queInd] = { ...nextQuestions[queInd], options: next };
                                  onMultipleChoiceChange({ target: { value: next } }, i, queInd, true);
                                }}
                                className="delete-icon"
                                icon="ooui:close"
                                width="20"
                                height="20"
                              />
                            ) : null}
                          </div>
                          <div className={classes.textandimgmain}>
                            <div className={classes.textandimg}>
                              <input
                                type="text"
                                placeholder="Enter option"
                                value={typeof opt === "object" ? (opt?.text ?? opt?.file_url ?? "") : (opt ?? "")}
                                disabled={que?.type === "true_false"}
                                onChange={(e) => onMultipleChoiceChange(e, i, queInd)}
                              />
                              {que?.type !== "true_false" && (
                                <>
                                  <div onClick={() => onIconOptionClick(`imageInput-${i}${queInd}`)} className={classes.queimg}>
                                    <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                    <input
                                      type="file"
                                      accept="image/*"
                                      id={`imageInput-${i}${queInd}`}
                                      onChange={(e) => onOptionImageChange(e, i, queInd)}
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                  {typeof opt === "object" && opt?.file_url ? (
                                    <div className={classes.preiewoptioncont}>
                                      <img src={opt.file_url} alt={`Option ${i + 1}`} />
                                      <Icon
                                        icon="material-symbols:delete-outline"
                                        width="20"
                                        height="20"
                                        className="delete-icon"
                                        onClick={() => onRemoveOptionImage(i, queInd)}
                                      />
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </div>
                          </div>
                          <div className="text-align-left" style={{ marginTop: 5 }}>
                            <div className={classes.correctcontainer}>
                              <input
                                type={que?.type === "checkbox" ? "checkbox" : "radio"}
                                name={que?.type === "checkbox" ? `answer-checkbox-${queInd}` : `answer-${queInd}`}
                                value={i}
                                checked={que?.type === "checkbox"
                                  ? (que?.answer || []).includes(i)
                                  : (que?.answer || [])[0] === i}
                                onChange={(e) => onCorrectChoiceChange(e, i, queInd)}
                              />
                              <label className={classes.correctlabel} htmlFor="Is Correct">is correct</label>
                            </div>
                            {validator.message(
                              `answer_${queInd}`,
                              (que?.answer || []).length > 0 ? que.answer : null,
                              "required"
                            )}
                          </div>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                )}

                {que?.type === "multiple_choice" && (
                  <div className={classes.addoption} onClick={() => onAdditionalOptions(queInd)}>
                    <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                    <p>Add another option</p>
                  </div>
                )}
                {que?.type === "checkbox" && (
                  <div className={classes.addoption} onClick={() => onAdditionalOptions(queInd)}>
                    <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                    <p>Add another checkbox</p>
                  </div>
                )}
              </div>
            </Grid>
          ))}
        </Grid>
      </div>

      {!hideAddQuestionAction && (
        <div className={classes.addque}>
          <Icon icon="octicon:feed-plus-16" width="16" height="16" />
          <p onClick={onAdditionalQuestion}>Add question</p>
        </div>
      )}

      <div
        style={{
          width: isSmallScreen ? "100%" : "50%",
          marginTop: 30,
          marginInline: "auto",
          display: "flex",
          justifyContent: "center",
          gap: 16,
          flexWrap: isSmallScreen ? "wrap" : "nowrap"
        }}
      >
        {footerMode === "edit_triple" ? (
          <>
            <Button
              variant="primaryoutline"
              buttonSize={isSmallScreen ? "full" : "fluid"}
              color="btnfontprimary"
              isLoading={isDraftLoading}
              onClick={onSaveDraft}
              buttonName="Update"
            />
            <Button
              variant="primary"
              buttonSize={isSmallScreen ? "full" : "fluid"}
              color="btndefault"
              buttonName="Publish questions"
              isLoading={isEditPublishing}
              onClick={onEditPublish}
            />
          </>
        ) : footerMode === "edit_withdraw" ? (
          <Button
            variant="primary"
            buttonSize={isSmallScreen ? "full" : "fluid"}
            color="btndefault"
            buttonName="Withdraw"
            isLoading={isWithdrawLoading}
            onClick={onEditWithdraw}
          />
        ) : (
          <>
            <Button
              variant="primaryoutline"
              buttonSize={isSmallScreen ? "full" : "fluid"}
              color="btnfontprimary"
              isLoading={isDraftLoading}
              onClick={onSaveDraft}
              buttonName="Save as Draft"
            />
            <Button
              variant="primary"
              buttonSize={isSmallScreen ? "full" : "fluid"}
              color="btndefault"
              buttonName={primaryButtonLabel}
              isLoading={isPrimaryLoading}
              onClick={onPrimaryAction}
            />
          </>
        )}
      </div>
    </>
  );
}

const EnrolmentExaminationDetails = () => {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { userRole } = useUserState();
  const isAdmin = userRole?.role_type === "school_admin";
  const [enrolmentExamData, setEnrolmentExamData] = useState([]);
  const [value, setValue] = useState("1");
  const [assignmentAttendees, setAssignmentAttendees] = useState([]);
  const [attendeeFilter, setAttendeeFilter] = useState([]);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isGenerateDrawerOpen, setIsGenerateDrawerOpen] = useState(false);
  const isSmallScreen = useWindowSize() < 600;

  const [isMetadataDrawerOpen, setIsMetadataDrawerOpen] = useState(false);
  const [configForm, setConfigForm] = useState({
    title: "",
    subject: "",
    description: "",
    instructions: "",
    duration: 0,
    proctoring_requirements: "",
    browser_lockdown: false
  });
  const [configValidator, showConfigValidator] = useValidator();

  const [isAddQuestionModalOpen, setIsAddQuestionModalOpen] = useState(false);
  const [isEditQuestionsModalOpen, setIsEditQuestionsModalOpen] = useState(false);
  const [questionArr, setQuestionArr] = useState([]);
  const [editQuestionArr, setEditQuestionArr] = useState([]);

  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isWithdrawingEnrolment, setIsWithdrawingEnrolment] = useState(false);

  const [questionsValidator, showQuestionsValidator] = useValidator();

  const makeEnrolmentImageHandlers = (arrState, setArrState) => {
    const handleQuestionImageChange = async (event, queInd) => {
      if (event?.target?.files?.length > 0) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        try {
          const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
          if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
            const uploadedImageDetails = {
              upload_id: response?.data?.data?.[0]?.upload_id,
              file_url: response?.data?.data?.[0]?.file_url
            };
            setArrState((prev) => prev.map((q, idx) => idx === queInd ? { ...q, file: uploadedImageDetails } : q));
            toast.success(`Image added to question ${queInd + 1}`);
          } else {
            toast.error(response?.data);
          }
        } catch (error) {
          toast.error(error?.response?.message);
        }
      }
    };
    const handleOptionImageChange = async (event, optionIndex, queInd) => {
      if (event?.target?.files?.length > 0) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        try {
          const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
          if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
            const uploadedImageDetails = {
              upload_id: response.data.data[0].upload_id,
              file_url: response.data.data[0].file_url
            };
            setArrState((prev) => prev.map((q, qIndex) => {
              if (qIndex === queInd) {
                const updatedOptions = q.options.map((opt, oIndex) => oIndex === optionIndex ? uploadedImageDetails : opt);

                return { ...q, options: updatedOptions };
              }

              return q;
            }));
            toast.success(`Image added to option ${optionIndex + 1} in question ${queInd + 1}`);
          } else {
            toast.error(response?.data);
          }
        } catch (error) {
          toast.error(error?.response?.message);
        }
      }
    };
    const removeQueImage = async (queInd) => {
      const upload_id = arrState[queInd]?.file?.upload_id;
      if (!upload_id) {
        toast.error("No upload ID found for this question");

        return;
      }
      try {
        const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);
        if (response?.status === 200) {
          setArrState((prev) => prev.map((q, idx) => idx === queInd ? { ...q, file: { upload_id: "", file_url: "" } } : q));
          toast.success(`Image removed from question ${queInd + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    };
    const removeOptionImage = async (optionIndex, queInd) => {
      const option = arrState[queInd]?.options?.[optionIndex];
      const upload_id = option?.upload_id;
      if (!upload_id) {
        toast.error("No upload ID found for this option");

        return;
      }
      try {
        const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);
        if (response?.status === 200) {
          setArrState((prev) => prev.map((q, qIndex) => {
            if (qIndex === queInd) {
              const updatedOptions = q.options.map((opt, oIndex) => oIndex === optionIndex ? { ...opt, upload_id: "", file_url: "" } : opt);

              return { ...q, options: updatedOptions };
            }

            return q;
          }));
          toast.success(`Option ${optionIndex + 1} image removed successfully`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    };

    return { handleQuestionImageChange, handleOptionImageChange, removeQueImage, removeOptionImage };
  };

  const addImageHandlers = makeEnrolmentImageHandlers(questionArr, setQuestionArr);
  const editImageHandlers = makeEnrolmentImageHandlers(editQuestionArr, setEditQuestionArr);

  const handleIconSharedClick = (idStr) => {
    const el = document.getElementById(idStr);
    if (el) el.click();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const columns = [
    {
      name: "Student Name",
      selector: row => row?.student?.name
    },
    {
      name: "Class Name",
      selector: row => row?.class?.name
    },
    {
      name: "Status",
      selector: row => <Badge status={row?.status} />
    },
    {
      name: "Submission",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.submission_id} className="table-action-container">
          <Link to={`/assignment/submission/${row?.submission_id}`} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </Link>
        </div>
      )
    }
  ];

  /**
   * Function to fetch enrolment examination details by ID.
   * This function makes an API call to get the enrolment examination data by its ID.
   */
  const getEnrolmentExaminationById = () => {
    httprequest.get(`${ENROLMENT_EXAM_ENDPOINT}/${id}`).then((res) => {
      const raw = res?.data?.data;
      const config = raw?.config ?? null;
      if (config) {
        setEnrolmentExamData({
          ...raw,
          ...config,
          // normalize fields used in UI
          subject: config?.subject ?? raw?.subject,
          instruction: config?.instructions ?? raw?.instruction ?? "",
          classes: Array.isArray(config?.classes) ? config.classes : (raw?.classes ?? []),
          status: config?.status ?? raw?.status,
          questions: raw?.questions ?? []
        });
      } else {
        setEnrolmentExamData(raw);
      }
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const configId = enrolmentExamData?.config?.id ?? enrolmentExamData?.id ?? id;
  const hasQuestions = (enrolmentExamData?.questions?.length ?? 0) > 0;
  const enrolmentExamStatus = String(enrolmentExamData?.status ?? "").trim().toLowerCase();
  const isPublishedEnrolmentExam = enrolmentExamStatus === "published";
  const canGenerateQuestions = ["draft", "withdrawn", "empty", ""].includes(enrolmentExamStatus);
  const isEnrolmentExamExpired = enrolmentExamStatus === "expired";

  const buildSearchWithEditConfig = () => {
    const params = new URLSearchParams(location.search);
    params.delete("editConfig");
    const base = params.toString();

    return base ? `?${base}&editConfig` : "?editConfig";
  };

  const handleOpenMetadataDrawer = () => {
    setConfigForm({
      title: enrolmentExamData?.title ?? "",
      subject: enrolmentExamData?.subject ?? "",
      description: enrolmentExamData?.description ?? "",
      instructions: enrolmentExamData?.instruction ?? enrolmentExamData?.instructions ?? "",
      duration: enrolmentExamData?.duration ?? 0,
      proctoring_requirements: enrolmentExamData?.proctoring_requirements?.level ?? "",
      browser_lockdown: !!enrolmentExamData?.browser_lockdown_settings
    });
    setIsMetadataDrawerOpen(true);
  };

  const handleCloseMetadataDrawer = () => {
    const params = new URLSearchParams(location.search);
    params.delete("editConfig");
    const nextSearch = params.toString();
    navigate({ pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : "" });
    setIsMetadataDrawerOpen(false);
  };

  useEffect(() => {
    const shouldOpen = searchParams.has("editConfig");
    if (shouldOpen && !isMetadataDrawerOpen && enrolmentExamData && Object.keys(enrolmentExamData).length > 0) {
      handleOpenMetadataDrawer();
    }
  }, [searchParams, enrolmentExamData, isMetadataDrawerOpen]);

  const handleConfigChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfigForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSaveConfig = () => {
    if (!configValidator.allValid()) {
      showConfigValidator(true);

      return;
    }
    const payload = {
      title: (configForm.title || "").trim() || null,
      subject: (configForm.subject || "").trim() || null,
      description: configForm.description ?? "",
      instructions: configForm.instructions ?? "",
      duration: Number(configForm.duration) || 0
    };

    if (configForm.proctoring_requirements) {
      payload.proctoring_requirements = { level: configForm.proctoring_requirements };
    }
    if (configForm.browser_lockdown) {
      payload.browser_lockdown_settings = {};
    }
    httprequest
      .patch(`${ENROLMENT_EXAM_CONFIG_ENDPOINT}/${configId}`, payload)
      .then(() => {
        toast.success("Enrolment exam config updated.");
        handleCloseMetadataDrawer();
        getEnrolmentExaminationById();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message ?? "Failed to update config.");
      });
  };

  const blankQuestion = (index) => ({
    question_text: "",
    type: "",
    options: [""],
    answer: [],
    grade_point: 0,
    required: false,
    add_to_bank: false,
    file: {},
    question_index: index
  });

  const normalizeQuestionForForm = (q) => ({
    id: q?.id ?? null,
    question_text: q?.question_text ?? q?.question ?? "",
    type: q?.type ?? "",
    file: q?.file || {},
    options: Array.isArray(q?.options) ? q.options : [""],
    answer: Array.isArray(q?.answer) ? q.answer : (q?.answer != null ? [q.answer] : []),
    grade_point: q?.grade_point ?? 0,
    required: !!q?.required,
    add_to_bank: !!q?.add_to_bank,
    question_index: q?.question_index ?? 0
  });

  const handleOpenAddQuestionModal = () => {
    const seeded = (enrolmentExamData?.questions?.length ?? 0) > 0
      ? enrolmentExamData.questions.map(normalizeQuestionForForm)
      : [blankQuestion(1)];
    setQuestionArr(seeded);
    setIsAddQuestionModalOpen(true);
  };

  const handleOpenEditQuestionsModal = () => {
    const seeded = (enrolmentExamData?.questions?.length ?? 0) > 0
      ? enrolmentExamData.questions.map(normalizeQuestionForForm)
      : [blankQuestion(1)];
    setEditQuestionArr(seeded);
    setIsEditQuestionsModalOpen(true);
  };

  const buildQuestionsPayload = (arr) => (arr || []).map((q) => ({
    ...(q?.id ? { id: q.id } : {}),
    type: q.type,
    question_text: (q.question_text || "").trim(),
    file: q.file || null,
    options: (q.options || []).map((opt) => (typeof opt === "object" && opt !== null && opt?.file_url ? opt : (typeof opt === "object" ? opt?.text : opt))),
    answer: Array.isArray(q.answer) ? q.answer : [],
    grade_point: Number(q.grade_point) || 0
  }));

  const configQuestionsUrl = `${ENROLMENT_EXAM_CONFIG_ENDPOINT}/${configId}/questions`;
  const configSaveUrl = `${ENROLMENT_EXAM_CONFIG_ENDPOINT}/${configId}/save`;

  const handleAddDraft = () => {
    if (!questionsValidator.allValid()) {
      showQuestionsValidator(true);

      return;
    }
    setIsDraftSaving(true);
    const questions = buildQuestionsPayload(questionArr);
    httprequest
      .post(configQuestionsUrl, { questions })
      .then(() => {
        return httprequest.post(configSaveUrl, { status: "draft", enrolment_id: enrolmentExamData?.enrolment_id || configId });
      })
      .then(() => {
        setIsDraftSaving(false);
        toast.success("Saved as draft.");
        setIsAddQuestionModalOpen(false);
        getEnrolmentExaminationById();
      })
      .catch((err) => {
        setIsDraftSaving(false);
        toast.error(err?.response?.data?.message ?? "Failed to save draft.");
      });
  };

  const handleAddPublish = () => {
    if (!questionsValidator.allValid()) {
      showQuestionsValidator(true);

      return;
    }
    setIsPublishing(true);
    const questions = buildQuestionsPayload(questionArr);
    httprequest
      .post(configQuestionsUrl, { questions })
      .then(() => {
        return httprequest.post(configSaveUrl, { status: "published", enrolment_id: enrolmentExamData?.enrolment_id || configId });
      })
      .then(() => {
        setIsPublishing(false);
        toast.success("Exam published successfully.");
        setIsAddQuestionModalOpen(false);
        getEnrolmentExaminationById();
      })
      .catch((err) => {
        setIsPublishing(false);
        toast.error(err?.response?.data?.message ?? "Failed to publish exam.");
      });
  };

  const handleEditDraft = () => {
    if (!questionsValidator.allValid()) {
      showQuestionsValidator(true);

      return;
    }
    setIsDraftSaving(true);
    const questions = buildQuestionsPayload(editQuestionArr);
    httprequest
      .post(configQuestionsUrl, { questions })
      .then(() => {
        return httprequest.post(configSaveUrl, { status: "draft", enrolment_id: enrolmentExamData?.enrolment_id || configId });
      })
      .then(() => {
        setIsDraftSaving(false);
        toast.success("Updated draft successfully.");
        setIsEditQuestionsModalOpen(false);
        getEnrolmentExaminationById();
      })
      .catch((err) => {
        setIsDraftSaving(false);
        toast.error(err?.response?.data?.message ?? "Failed to update draft.");
      });
  };

  const handleEditPublish = () => {
    if (!questionsValidator.allValid()) {
      showQuestionsValidator(true);

      return;
    }
    setIsPublishing(true);
    const questions = buildQuestionsPayload(editQuestionArr);
    httprequest
      .post(configQuestionsUrl, { questions })
      .then(() => {
        return httprequest.post(configSaveUrl, { status: "published", enrolment_id: enrolmentExamData?.enrolment_id || configId });
      })
      .then(() => {
        setIsPublishing(false);
        toast.success("Exam published successfully.");
        setIsEditQuestionsModalOpen(false);
        getEnrolmentExaminationById();
      })
      .catch((err) => {
        setIsPublishing(false);
        toast.error(err?.response?.data?.message ?? "Failed to publish exam.");
      });
  };

  const handleEditWithdraw = () => {
    if (!questionsValidator.allValid()) {
      showQuestionsValidator(true);

      return;
    }
    setIsWithdrawingEnrolment(true);
    const questions = buildQuestionsPayload(editQuestionArr);
    httprequest
      .post(configQuestionsUrl, { questions })
      .then(() => {
        return httprequest.post(configSaveUrl, { status: "withdrawn", enrolment_id: enrolmentExamData?.enrolment_id || configId });
      })
      .then(() => {
        setIsWithdrawingEnrolment(false);
        toast.success("Exam withdrawn successfully.");
        setIsEditQuestionsModalOpen(false);
        getEnrolmentExaminationById();
      })
      .catch((err) => {
        setIsWithdrawingEnrolment(false);
        toast.error(err?.response?.data?.message ?? "Failed to withdraw exam.");
      });
  };

  const onQueChangeFactory = (setter) => (e, idx) => {
    const { value } = e.target;
    setter((prev) => prev.map((q, i) => (i === idx ? { ...q, question_text: value } : q)));
  };
  const onQuePointChangeFactory = (setter) => (e, idx) => {
    const { value } = e.target;
    setter((prev) => prev.map((q, i) => (i === idx ? { ...q, grade_point: value } : q)));
  };
  const onQueTypeChangeFactory = (setter) => (e, idx) => {
    const { value } = e.target;
    setter((prev) => prev.map((q, i) => {
      if (i !== idx) {
        return q;
      }
      if (value === "true_false") {
        return { ...q, type: value, options: ["True", "False"], answer: [] };
      }
      const options = (q.options && q.options.length > 0) ? q.options : [""];

      return { ...q, type: value, options, answer: [] };
    }));
  };
  const onMultipleChoiceChangeFactory = (setter) => (e, optIdx, qIdx) => {
    const { value } = e.target;
    setter((prev) => prev.map((q, i) => {
      if (i !== qIdx) {
        return q;
      }
      const nextOpts = [...(q.options || [])];
      nextOpts[optIdx] = value;

      return { ...q, options: nextOpts };
    }));
  };
  const onCorrectChoiceChangeFactory = (setter) => (e, optIdx, qIdx) => {
    setter((prev) => prev.map((q, i) => {
      if (i !== qIdx) {
        return q;
      }
      if (q.type === "checkbox") {
        const arr = Array.isArray(q.answer) ? [...q.answer] : [];
        const exists = arr.includes(optIdx);
        const next = exists ? arr.filter((x) => x !== optIdx) : [...arr, optIdx];

        return { ...q, answer: next };
      }

      return { ...q, answer: [optIdx] };
    }));
  };
  const onAdditionalOptionsFactory = (setter) => (qIdx) => {
    setter((prev) => prev.map((q, i) => {
      if (i !== qIdx) {
        return q;
      }
      if (q.type === "true_false") {
        return q;
      }

      return { ...q, options: [...(q.options || []), ""] };
    }));
  };
  const onAdditionalQuestionFactory = (setter) => () => {
    setter((prev) => [...prev, blankQuestion((prev?.length ?? 0) + 1)]);
  };
  const onRemoveQuestionFactory = (setter) => (qIdx) => {
    setter((prev) => prev.filter((_q, i) => i !== qIdx));
  };

  /**
   * Function to fetch enrolment examination recipients.
   * This function retrieves the list of students who are recipients of the enrolment examination.
   */
  const getEnrolmentExaminationRecipient = () => {
    httprequest.get(`${ENROLMENT_EXAM_ENDPOINT}/students/${id}`).then((res) => {
      setAssignmentAttendees(res?.data?.data);
      setAttendeeFilter(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
  * Function to handle search in enrolment examination attendees.
  * This function filters the list of attendees based on the search input.
  * @param {*} e - Event object from the search input
  * Function to handle search in enrolment examination attendees.
  */
  const handleSearchEnrolExam = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = assignmentAttendees?.filter((data) => valArray?.every(
      (word) => data?.student_name
        ?.toLowerCase()
        .includes(word.toLowerCase())
    )
    );
    setAttendeeFilter(result);
  };

  /**
   * Effect hook to fetch enrolment examination data based on the selected tab.
   * This effect runs when the `value` state changes, indicating a tab switch.
   */
  useEffect(() => {
    if (value === "1") {
      getEnrolmentExaminationById();
    } else {
      getEnrolmentExaminationRecipient();
    }
  }, [value]);

  /**
   * Function to export enrolment examination data to a Word document.
   * @returns Function to export enrolment examination data to a Word document.
   * This function generates a Word document from the enrolment examination data and prompts the user to download it.
   */
  const exportToWord = () => {
    if (!enrolmentExamData || !enrolmentExamData.questions) {
      toast.error("No exam data available.");

      return;
    }

    let htmlContent = `
      <h1>${enrolmentExamData.title || "Enrolment Examination"}</h1>
      <p><strong>Created By:</strong> ${enrolmentExamData?.created_by?.last_name} ${enrolmentExamData?.created_by?.first_name || ""}</p>
      <p><strong>Subject:</strong> ${enrolmentExamData?.subject || "--/--"}</p>
      <p><strong>Classes:</strong> ${enrolmentExamData?.classes?.map(clss => clss?.name).join(", ") || "--/--"}</p>
      <hr />
      <h2>Questions:</h2>
    `;

    enrolmentExamData.questions.forEach((question, idx) => {
      htmlContent += `
        <div style="margin-bottom: 20px;">
          <h3>Q${questionDisplayIndex(question, idx, enrolmentExamData.questions)}: ${question.question}</h3>
          ${question?.file?.file_url ? `<img src="${question.file.file_url}" width="200"/>` : ""}
          <ul>
            ${question.options.map((option) => {
    const content = typeof option === "object" && option?.file_url
      ? `<img src="${option.file_url}" width="150"/>`
      : option;

    return `<li>${content}</li>`;
  }).join("")}
          </ul>
        </div>
      `;
    });

    const blob = HTMLDocx.asBlob(htmlContent);
    saveAs(blob, `${enrolmentExamData.subject} ${enrolmentExamData.title || "exam"}.docx`);
    setIsExportModalOpen(false);
    toast.success("Examination Exported successfully");
  };

  const handleExportModalToggle = () => {
    setIsExportModalOpen(!isExportModalOpen);
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/enrolments/enrolment-examination"
                link_one_name="Enrolment Examination"
                active={`${enrolmentExamData?.subject} Enrolment Exam`}
                description="See the details of this Enrolment Examination"
              />
            </div>
          </div>
          <div className="page-content">
            <PageTitle className={classes.inline}
              title={`${enrolmentExamData?.title}`}
              subtitle={`Created By: ${enrolmentExamData?.created_by?.last_name} ${enrolmentExamData?.created_by?.first_name} | Class: ${enrolmentExamData?.classes?.map((class_names) => class_names?.name).join(", ")} `}
              button={
                <div className={classes.actionIconGroup}>
                  <Tooltip title="Export to Word" arrow placement="top">
                    <button
                      type="button"
                      className={classes.exportIconBtn}
                      onClick={handleExportModalToggle}
                      aria-label="Export to Word"
                    >
                      <Icon icon="flowbite:file-export-outline" width="22" height="22" />
                    </button>
                  </Tooltip>
                  {!isPublishedEnrolmentExam && (
                    <Tooltip title="Add Questions" arrow placement="top">
                      <button
                        type="button"
                        className={classes.editIconBtn}
                        onClick={handleOpenAddQuestionModal}
                        aria-label="Add Questions"
                      >
                        <Icon icon="mdi:plus" width="22" height="22" />
                      </button>
                    </Tooltip>
                  )}
                  <Tooltip title="Edit Enrolment Examination" arrow placement="top">
                    <button
                      type="button"
                      className={classes.exportIconBtn}
                      onClick={() => navigate({ pathname: location.pathname, search: buildSearchWithEditConfig() })}
                      aria-label="Edit Enrolment Examination"
                    >
                      <Icon icon="fluent:edit-16-regular" width="22" height="22" />
                    </button>
                  </Tooltip>
                  {canGenerateQuestions && (
                    <Tooltip title="Generate Questions" arrow placement="top">
                      <button
                        type="button"
                        className={classes.editIconBtn}
                        onClick={() => setIsGenerateDrawerOpen(true)}
                        aria-label="Generate Questions"
                      >
                        <Icon icon="fluent-color:bot-sparkle-16" width="22" height="22" />
                      </button>
                    </Tooltip>
                  )}
                </div>
              }
            />
            <TabContext value={value}>
              <div className="tablist-container">
                <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
                  <Tab label="Enrolment Examination Details" value="1" />
                  {/* <Tab label="Attendees" value="2" /> */}
                </Tabs>
              </div>
              <TabPanel value="1" className="tabpanel-overide">
                <Grid container spacing={1}>
                  <div className="key-pair-container">
                    <Grid container spacing={1}>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Subject Name" subtitle={enrolmentExamData?.subject || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText title="Created By" subtitle={`${enrolmentExamData?.created_by?.last_name} ${enrolmentExamData?.created_by?.first_name}` || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText title="Created at" subtitle={enrolmentExamData?.created_at?.substring(0, 10) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Title" subtitle={enrolmentExamData?.title || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText title="Updated At" subtitle={enrolmentExamData?.updated_at?.substring(0, 10) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText
                          title="Status"
                          subtitle={
                            <div className="subtitle-container">
                              {<Badge status={enrolmentExamData?.status} /> || "--/--"}
                            </div>
                          }
                        />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Visibility" subtitle={enrolmentExamData?.is_private ? "Private" : "Public"} />
                      </Grid>
                      <Grid item lg={2} md={4} sm={6} xs={12}>
                        <AssignmentDetailText title="Instruction" subtitle={enrolmentExamData?.instruction || "--/--"} />
                      </Grid>
                    </Grid>
                  </div>
                  {/* <div className="key-pair-container">
                    <div className="key-pair-content">
                      <p className="key-pair-name">Status</p>
                      <h3 className="key-pair-value"> <Badge status={enrolmentExamData?.status} /></h3>
                    </div>
                  </div> */}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <WidgetTitle
                      title="Questions"
                      link={hasQuestions && !isPublishedEnrolmentExam ? (
                        <Button
                          variant="primaryoutline"
                          color="btnfontprimary"
                          buttonSize="fluid"
                          onClick={handleOpenEditQuestionsModal}
                          buttonName="Edit Questions"
                          disabled={isEnrolmentExamExpired}
                        />
                      ) : null}
                    />
                    {!hasQuestions ? (
                      <div style={{ minHeight: 280, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40 }}>
                        <NotFounditem
                          img={noexam}
                          title="No questions have been added"
                          subtitle="Add questions for this enrolment exam"
                        >
                          {!isPublishedEnrolmentExam && (
                            <Button
                              variant="primary"
                              color="btndefault"
                              buttonSize="fluid"
                              onClick={handleOpenAddQuestionModal}
                              buttonName="Add Questions"
                            />
                          )}
                        </NotFounditem>
                      </div>
                    ) : (
                      <Grid container spacing={2}>
                        {enrolmentExamData?.questions?.map((item, i) => {
                          const hasImageOption = item?.options?.some(option => typeof option === "object" && option.file_url);

                          return (
                            <Grid item lg={4} md={6} sm={12} xs={12} key={i}>
                              <div className="question-preview-container">
                                <h3 className="question-preview-heading">
                                  Question {questionDisplayIndex(item, i, enrolmentExamData?.questions)}
                                </h3>
                                <div className={classes.question}>
                                  <h3 className="question-preview-heading">
                                    {item?.question} {item?.required ? <span className="input-required">*</span> : null}
                                    {item?.file && (
                                      <div className={classes.quesdisplay}>
                                        <img src={item?.file?.file_url} alt="" />
                                      </div>
                                    )}
                                  </h3>

                                  {(item?.type === "multiple_choice" || item?.type === "true_false") ? (
                                    hasImageOption ? (
                                      <Grid container spacing={2}>
                                        {item?.options?.map((option, i) => {
                                          const isImageOption = typeof option === "object" && option.file_url;

                                          return (
                                            <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                                              <div className="options-preview">
                                                <input type="radio" checked={enrolmentExamData?.questions[item?.question_index - 1]?.answer?.includes(i)} name={item?.question_index} />
                                                {isImageOption ? (
                                                  <div className={classes.optiondisplay}>
                                                    <img src={option.file_url} alt={`Option ${i + 1}`} />
                                                  </div>
                                                ) : (
                                                  <label>{option}</label>
                                                )}
                                              </div>
                                            </Grid>
                                          );
                                        })}
                                      </Grid>
                                    ) : (
                                      <>
                                        {item?.options?.map((option, i) => (
                                          <div key={i} className="options-preview">
                                            <input type="radio" checked={enrolmentExamData?.questions[item?.question_index - 1]?.answer?.includes(i)} name={item?.question_index} />
                                            <label>{option}</label>
                                          </div>
                                        ))}
                                      </>
                                    )
                                  ) : item?.type === "checkbox" ? (
                                    hasImageOption ? (
                                      <Grid container spacing={2}>
                                        {item?.options?.map((option, i) => {
                                          const isImageOption = typeof option === "object" && option.file_url;

                                          return (
                                            <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                                              <div className="options-preview">
                                                <input type="checkbox" checked={enrolmentExamData?.questions[item?.question_index - 1]?.answer?.includes(i)} name={item?.question_index} />
                                                {isImageOption ? (
                                                  <div className={classes.optiondisplay}>
                                                    <img src={option.file_url} alt={`Option ${i + 1}`} />
                                                  </div>
                                                ) : (
                                                  <label>{option}</label>
                                                )}
                                              </div>
                                            </Grid>
                                          );
                                        })}
                                      </Grid>
                                    ) : (
                                      <>
                                        {item?.options?.map((option, i) => (
                                          <div key={i} className="options-preview">
                                            <input type="checkbox" checked={enrolmentExamData?.questions[item?.question_index - 1]?.answer?.includes(i)} name={item?.question_index} />
                                            <label>{option}</label>
                                          </div>
                                        ))}
                                      </>
                                    )
                                  ) : null}
                                </div>
                              </div>
                            </Grid>
                          );
                        })}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="2">
                <Table data={attendeeFilter} columns={columns} subHeader={true} pagination subHeaderComponent={
                  attendeeFilter.length > 0 && (
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchEnrolExam} />
                  )}
                />
              </TabPanel>
            </TabContext>
            {/* <ToastContainer /> */}
            <Modal
              title="Export to Word"
              subtitle="Are you sure you want to export this examination to Word?"
              modalContent={<p>This will generate a Word document of this Examination.</p>}
              modalFooter={
                <>
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Confirm Export"
                    onClick={exportToWord}
                  />
                </>
              }
              isopen={isExportModalOpen}
              closeModal={handleExportModalToggle}
            />

            <RightDrawer
              open={isMetadataDrawerOpen}
              onClose={handleCloseMetadataDrawer}
              title="Edit Enrolment Exam Config"
            >
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Title"
                    inputName="title"
                    margin="normal"
                    inputType="text"
                    placeHolder="Enter title"
                    value={configForm.title}
                    onChange={handleConfigChange}
                    required
                  />
                  {configValidator.message("title", configForm.title?.trim(), "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Subject"
                    inputName="subject"
                    margin="normal"
                    inputType="text"
                    placeHolder="Enter subject"
                    value={configForm.subject}
                    onChange={handleConfigChange}
                    required
                  />
                  {configValidator.message("subject", configForm.subject?.trim(), "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextAreaGroup
                    label="Description"
                    inputName="description"
                    margin="normal"
                    placeholder="Enter description"
                    value={configForm.description}
                    onChange={handleConfigChange}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextAreaGroup
                    label="Instructions"
                    inputName="instructions"
                    margin="normal"
                    placeholder="Enter instructions"
                    value={configForm.instructions}
                    onChange={handleConfigChange}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Duration (minutes)"
                    inputName="duration"
                    margin="normal"
                    inputType="number"
                    placeHolder="Enter duration"
                    value={configForm.duration}
                    onChange={handleConfigChange}
                    required
                  />
                  {configValidator.message("duration", configForm.duration, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Proctoring requirements"
                    children={(
                      <select
                        name="proctoring_requirements"
                        value={configForm.proctoring_requirements}
                        onChange={handleConfigChange}
                      >
                        <option value="">--- Select ---</option>
                        <option value="none">None</option>
                        <option value="basic">Basic</option>
                        <option value="strict">Strict</option>
                      </select>
                    )}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 16 }}>
                    <FormControlLabel
                      control={(
                        <Switch
                          name="browser_lockdown"
                          checked={configForm.browser_lockdown}
                          onChange={(e) => {
                            setConfigForm((prev) => ({ ...prev, browser_lockdown: e.target.checked }));
                          }}
                          color="primary"
                        />
                      )}
                      label="Browser lockdown"
                    />
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Save Config"
                    onClick={handleSaveConfig}
                  />
                </Grid>
              </Grid>
            </RightDrawer>

            <Modal
              fullScreen
              title="Add questions"
              subtitle="Add questions, then save as draft or publish."
              isopen={isAddQuestionModalOpen}
              closeModal={() => {
                setIsAddQuestionModalOpen(false);
                setQuestionArr([]);
              }}
              modalContent={
                <QuestionsModalContent
                  questionArr={questionArr}
                  classes={classes}
                  validator={questionsValidator}
                  isSmallScreen={isSmallScreen}
                  onQueChange={onQueChangeFactory(setQuestionArr)}
                  onQueTypeChange={onQueTypeChangeFactory(setQuestionArr)}
                  onQuePointChange={onQuePointChangeFactory(setQuestionArr)}
                  onMultipleChoiceChange={onMultipleChoiceChangeFactory(setQuestionArr)}
                  onCorrectChoiceChange={onCorrectChoiceChangeFactory(setQuestionArr)}
                  onAdditionalOptions={onAdditionalOptionsFactory(setQuestionArr)}
                  onAdditionalQuestion={onAdditionalQuestionFactory(setQuestionArr)}
                  onRemoveQuestion={onRemoveQuestionFactory(setQuestionArr)}
                  isDraftLoading={isDraftSaving}
                  isPrimaryLoading={isPublishing}
                  onSaveDraft={handleAddDraft}
                  onPrimaryAction={handleAddPublish}
                  primaryButtonLabel="Publish"
                  footerMode="add"
                  onQueImageChange={addImageHandlers.handleQuestionImageChange}
                  onOptionImageChange={addImageHandlers.handleOptionImageChange}
                  onRemoveQueImage={addImageHandlers.removeQueImage}
                  onRemoveOptionImage={addImageHandlers.removeOptionImage}
                  onIconClick={handleIconSharedClick}
                  onIconOptionClick={handleIconSharedClick}
                />
              }
              modalFooter={null}
            />

            <Modal
              fullScreen
              title="Edit questions"
              subtitle="Update exam questions. Save as draft, publish, or withdraw."
              isopen={isEditQuestionsModalOpen}
              closeModal={() => setIsEditQuestionsModalOpen(false)}
              modalContent={
                <QuestionsModalContent
                  questionArr={editQuestionArr}
                  classes={classes}
                  validator={questionsValidator}
                  isSmallScreen={isSmallScreen}
                  onQueChange={onQueChangeFactory(setEditQuestionArr)}
                  onQueTypeChange={onQueTypeChangeFactory(setEditQuestionArr)}
                  onQuePointChange={onQuePointChangeFactory(setEditQuestionArr)}
                  onMultipleChoiceChange={onMultipleChoiceChangeFactory(setEditQuestionArr)}
                  onCorrectChoiceChange={onCorrectChoiceChangeFactory(setEditQuestionArr)}
                  onAdditionalOptions={onAdditionalOptionsFactory(setEditQuestionArr)}
                  onAdditionalQuestion={onAdditionalQuestionFactory(setEditQuestionArr)}
                  onRemoveQuestion={onRemoveQuestionFactory(setEditQuestionArr)}
                  isDraftLoading={isDraftSaving}
                  isPrimaryLoading={isPublishing}
                  onSaveDraft={handleEditDraft}
                  onPrimaryAction={handleEditPublish}
                  primaryButtonLabel="Publish"
                  footerMode={enrolmentExamData?.status === "published" ? "edit_withdraw" : "edit_triple"}
                  onEditPublish={handleEditPublish}
                  onEditWithdraw={handleEditWithdraw}
                  isEditPublishing={isPublishing}
                  isWithdrawLoading={isWithdrawingEnrolment}
                  hideAddQuestionAction={enrolmentExamData?.status === "published"}
                  onQueImageChange={editImageHandlers.handleQuestionImageChange}
                  onOptionImageChange={editImageHandlers.handleOptionImageChange}
                  onRemoveQueImage={editImageHandlers.removeQueImage}
                  onRemoveOptionImage={editImageHandlers.removeOptionImage}
                  onIconClick={handleIconSharedClick}
                  onIconOptionClick={handleIconSharedClick}
                />
              }
              modalFooter={null}
            />

            <GenerateQuestionsDrawer
              open={isGenerateDrawerOpen}
              onClose={() => setIsGenerateDrawerOpen(false)}
              isAdmin={isAdmin}
              lessonOutlineId={location.state?.lessonOutline?.lesson_outline_id}
              versionId={location.state?.lessonOutline?.version_id}
              initialDestinationType="enrolment_exam"
              initialDestinationId={configId}
              examContext={{
                title: enrolmentExamData?.title,
                subjectName: enrolmentExamData?.subject,
                subjectId: enrolmentExamData?.subject_id ?? enrolmentExamData?.config?.subject_id ?? enrolmentExamData?.subject,
                classLabel: (enrolmentExamData?.classes || []).map((cls) => cls?.name).filter(Boolean).join(", "),
                description: enrolmentExamData?.description || ""
              }}
            />

          </div>
        </>
      }
    />
  );
};

export default EnrolmentExaminationDetails;
